import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-icon/jb-icon.css.ts
var jb_icon_css_default = i`:host{block-size:var(--_iconsize);color:inherit;display:inline-flex;inline-size:var(--_iconsize);--_iconsize: 24px}:host([size="32"]){--_iconsize: 32px}:host([size="20"]),:host([size=small]){--_iconsize: 20px}:host([size="48"]),:host([size=large]){--_iconsize: 48px}svg{aspect-ratio:1;block-size:var(--_iconsize);inline-size:var(--_iconsize);overflow:visible}`;

export {
  jb_icon_css_default
};
